module.exports = __webpack_public_path__ + "img/sbp.b2292b45.svg";